import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";

/**
 * Saisie de l'effectif attendu d'une vague (total + par site + par statut),
 * pour calculer le taux de participation.
 */
const EffectifEditor = ({ show, onHide, effectif, sites, statuts, onSave }) => {
  const [total, setTotal] = useState("");
  const [parSite, setParSite] = useState({});
  const [parStatut, setParStatut] = useState({});

  useEffect(() => {
    const eff = effectif || {};
    setTotal(eff.total != null ? String(eff.total) : "");
    setParSite(eff.parSite || {});
    setParStatut(eff.parStatut || {});
  }, [effectif, show]);

  const setSite = (site, val) => setParSite((p) => ({ ...p, [site]: val }));
  const setStat = (st, val) => setParStatut((p) => ({ ...p, [st]: val }));

  const toIntMap = (m) => {
    const out = {};
    Object.keys(m).forEach((k) => {
      const v = m[k];
      if (v !== "" && v != null && !isNaN(Number(v))) out[k] = Number(v);
    });
    return out;
  };

  const handleSave = () => {
    onSave({
      total: total === "" ? null : Number(total),
      parSite: toIntMap(parSite),
      parStatut: toIntMap(parStatut),
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Effectif de la vague</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: "#666", fontSize: 13 }}>
          Nombre de personnes <b>attendues</b> (pas de réponses). Sert à calculer le taux de
          participation.
        </p>

        <Form.Group>
          <Form.Label>
            <b>Effectif total</b>
          </Form.Label>
          <Form.Control
            type="number"
            min="0"
            value={total}
            onChange={(e) => setTotal(e.target.value)}
            style={{ width: 140 }}
          />
        </Form.Group>

        {sites && sites.length > 0 && (
          <>
            <Form.Label style={{ marginTop: 8 }}>
              <b>Par site</b>
            </Form.Label>
            <Table size="sm" borderless>
              <tbody>
                {sites.map((s) => (
                  <tr key={s}>
                    <td style={{ verticalAlign: "middle" }}>{s.replace("Le Moulin - ", "")}</td>
                    <td style={{ width: 120 }}>
                      <Form.Control
                        type="number"
                        min="0"
                        size="sm"
                        value={parSite[s] != null ? parSite[s] : ""}
                        onChange={(e) => setSite(s, e.target.value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {statuts && statuts.length > 0 && (
          <>
            <Form.Label style={{ marginTop: 8 }}>
              <b>Par statut</b>
            </Form.Label>
            <Table size="sm" borderless>
              <tbody>
                {statuts.map((st) => (
                  <tr key={st}>
                    <td style={{ verticalAlign: "middle" }}>{st}</td>
                    <td style={{ width: 120 }}>
                      <Form.Control
                        type="number"
                        min="0"
                        size="sm"
                        value={parStatut[st] != null ? parStatut[st] : ""}
                        onChange={(e) => setStat(st, e.target.value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Annuler
        </Button>
        <Button style={{ background: "#429853", border: "none" }} onClick={handleSave}>
          Enregistrer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EffectifEditor;
